/* ========================================
   ADI Mock Data
   Realistic Italian Healthcare Data
   Based on Modello 431 & interRAI HC
   ======================================== */

export const patients = [
  {
    id: 1,
    nome: "Maria",
    cognome: "Rossi",
    codiceFiscale: "RSSMRA55D42H501B",
    dataNascita: "02/04/1955",
    eta: 71,
    sesso: "F",
    indirizzo: "Via Roma 45, 00185 Roma",
    comune: "Roma",
    cap: "00185",
    distretto: "ASL Roma 2 - Distretto 5",
    telefono: "+39 06 7654321",
    email: "m.rossi@email.it",
    diagnosiPrincipale: "Diabete Mellito Tipo 2 (ICD-9: 250.00)",
    diagnosiSecondaria: "Neuropatia diabetica (ICD-9: 357.2)",
    condizione: "Parzialmente Autosufficiente",
    caregiver: {
      presente: true,
      nome: "Luigi Rossi",
      relazione: "Figlio",
      telefono: "+39 333 1234567",
      coabitante: true,
    },
    priorita: "alta",
    prioritaLabel: "U-A (Alta - Entro 24h)",
    provenienza: "PUA",
    dataRichiesta: "15/01/2026",
    stato: "da_accettare",
    medicoRichiedente: "Dr. Paolo Conti",
    note: "Paziente con complicanze diabetiche multiple, necessita monitoraggio glicemico domiciliare e medicazioni quotidiane.",
    mmg: "Dr. Alessandro Bianchi",
  },
  {
    id: 2,
    nome: "Giuseppe",
    cognome: "Bianchi",
    codiceFiscale: "BNCGPP48A15F205X",
    dataNascita: "15/01/1948",
    eta: 78,
    sesso: "M",
    indirizzo: "Viale Europa 112, 00144 Roma",
    comune: "Roma",
    cap: "00144",
    distretto: "ASL Roma 2 - Distretto 7",
    telefono: "+39 06 9876543",
    email: "g.bianchi@email.it",
    diagnosiPrincipale: "Ipertensione arteriosa (ICD-9: 401.9)",
    diagnosiSecondaria: "Insufficienza cardiaca congestizia (ICD-9: 428.0)",
    condizione: "Parzialmente Autosufficiente",
    caregiver: {
      presente: true,
      nome: "Anna Bianchi",
      relazione: "Moglie",
      telefono: "+39 338 9876543",
      coabitante: true,
    },
    priorita: "media",
    prioritaLabel: "U-B (Media - Entro 72h)",
    provenienza: "Ospedale S. Giovanni",
    dataRichiesta: "16/01/2026",
    stato: "da_accettare",
    medicoRichiedente: "Dr.ssa Giulia Ferri",
    note: "Dimissione protetta post-ricovero per scompenso cardiaco. Necessita monitoraggio pressorio e terapia endovenosa.",
    mmg: "Dr. Marco Rizzo",
  },
  {
    id: 3,
    nome: "Anna",
    cognome: "Verdi",
    codiceFiscale: "VRDNNA72L63A944C",
    dataNascita: "23/07/1942",
    eta: 83,
    sesso: "F",
    indirizzo: "Via Tuscolana 320, 00181 Roma",
    comune: "Roma",
    cap: "00181",
    distretto: "ASL Roma 2 - Distretto 6",
    telefono: "+39 06 5432198",
    email: "",
    diagnosiPrincipale: "Frattura collo del femore (ICD-9: 820.0)",
    diagnosiSecondaria: "Osteoporosi post-menopausale (ICD-9: 733.01)",
    condizione: "Non Autosufficiente",
    caregiver: {
      presente: true,
      nome: "Francesca Verdi",
      relazione: "Figlia",
      telefono: "+39 347 5432198",
      coabitante: false,
    },
    priorita: "bassa",
    prioritaLabel: "U-C (Bassa - Entro 10gg)",
    provenienza: "PUA",
    dataRichiesta: "14/01/2026",
    stato: "presa_in_carico",
    medicoRichiedente: "Dr. Roberto Neri",
    note: "Intervento chirurgico al femore il 05/01, fase di riabilitazione post-operatoria. Fisioterapia domiciliare.",
    mmg: "Dr.ssa Laura Fabbri",
    medicoAssegnato: "Dr.ssa Elena Moretti",
    dataVisitaUVMD: "20/01/2026",
  },
  {
    id: 4,
    nome: "Luca",
    cognome: "Esposito",
    codiceFiscale: "SPSLCU66B12F839M",
    dataNascita: "12/02/1946",
    eta: 80,
    sesso: "M",
    indirizzo: "Via Appia Nuova 678, 00179 Roma",
    comune: "Roma",
    cap: "00179",
    distretto: "ASL Roma 2 - Distretto 5",
    telefono: "+39 06 3216549",
    email: "l.esposito@email.it",
    diagnosiPrincipale: "BPCO riacutizzata (ICD-9: 491.21)",
    diagnosiSecondaria: "Enfisema polmonare (ICD-9: 492.8)",
    condizione: "Non Autosufficiente",
    caregiver: {
      presente: true,
      nome: "Paolo Esposito",
      relazione: "Figlio",
      telefono: "+39 339 3216549",
      coabitante: true,
    },
    priorita: "alta",
    prioritaLabel: "U-A (Alta - Entro 24h)",
    provenienza: "Ospedale Tor Vergata",
    dataRichiesta: "17/01/2026",
    stato: "da_accettare",
    medicoRichiedente: "Dr. Antonio Greco",
    note: "Dimissione urgente, paziente ossigeno-dipendente. Necessita ventilazione non invasiva e monitoraggio saturazione.",
    mmg: "Dr. Stefano Mancini",
  },
  {
    id: 5,
    nome: "Francesca",
    cognome: "Romano",
    codiceFiscale: "RMNFNC60H58H501D",
    dataNascita: "18/06/1960",
    eta: 65,
    sesso: "F",
    indirizzo: "Via Casilina 455, 00176 Roma",
    comune: "Roma",
    cap: "00176",
    distretto: "ASL Roma 2 - Distretto 6",
    telefono: "+39 06 8527419",
    email: "f.romano@email.it",
    diagnosiPrincipale: "Insufficienza cardiaca (ICD-9: 428.0)",
    diagnosiSecondaria: "Fibrillazione atriale (ICD-9: 427.31)",
    condizione: "Parzialmente Autosufficiente",
    caregiver: {
      presente: false,
      nome: "",
      relazione: "",
      telefono: "",
      coabitante: false,
    },
    priorita: "media",
    prioritaLabel: "U-B (Media - Entro 72h)",
    provenienza: "PUA",
    dataRichiesta: "13/01/2026",
    stato: "presa_in_carico",
    medicoRichiedente: "Dr.ssa Chiara Lombardi",
    note: "Paziente vive sola, necessità di attivazione servizi sociali. Monitoraggio cardiaco e supporto infermieristico.",
    mmg: "Dr.ssa Sara Colombo",
    medicoAssegnato: "Dr. Marco Vitale",
    dataVisitaUVMD: "19/01/2026",
  },
  {
    id: 6,
    nome: "Antonio",
    cognome: "Colombo",
    codiceFiscale: "CLMNTN50S22F205L",
    dataNascita: "22/11/1950",
    eta: 75,
    sesso: "M",
    indirizzo: "Piazza Bologna 8, 00162 Roma",
    comune: "Roma",
    cap: "00162",
    distretto: "ASL Roma 1 - Distretto 3",
    telefono: "+39 06 7418529",
    email: "a.colombo@email.it",
    diagnosiPrincipale: "Ictus cerebrale ischemico (ICD-9: 434.91)",
    diagnosiSecondaria: "Disfagia (ICD-9: 787.20)",
    condizione: "Non Autosufficiente",
    caregiver: {
      presente: true,
      nome: "Maria Colombo",
      relazione: "Moglie",
      telefono: "+39 349 7418529",
      coabitante: true,
    },
    priorita: "alta",
    prioritaLabel: "U-A (Alta - Entro 24h)",
    provenienza: "Ospedale Gemelli",
    dataRichiesta: "17/01/2026",
    stato: "in_valutazione",
    medicoRichiedente: "Dr.ssa Valentina Costa",
    note: "Post-ictus con emiparesi sinistra. Necessita riabilitazione neuromotoria intensiva e logopedia per disfagia.",
    mmg: "Dr. Fabio Ricci",
    medicoAssegnato: "Dr.ssa Elena Moretti",
    dataVisitaUVMD: "18/01/2026",
  },
  {
    id: 7,
    nome: "Elena",
    cognome: "Ferrara",
    codiceFiscale: "FRRLNE43T55A662G",
    dataNascita: "15/12/1943",
    eta: 82,
    sesso: "F",
    indirizzo: "Via Prenestina 890, 00155 Roma",
    comune: "Roma",
    cap: "00155",
    distretto: "ASL Roma 2 - Distretto 7",
    telefono: "+39 06 6543217",
    email: "",
    diagnosiPrincipale: "Demenza senile tipo Alzheimer (ICD-9: 331.0)",
    diagnosiSecondaria: "Diabete Mellito Tipo 1 (ICD-9: 250.01)",
    condizione: "Non Autosufficiente",
    caregiver: {
      presente: true,
      nome: "Marco Ferrara",
      relazione: "Figlio",
      telefono: "+39 340 6543217",
      coabitante: true,
    },
    priorita: "media",
    prioritaLabel: "U-B (Media - Entro 72h)",
    provenienza: "PUA",
    dataRichiesta: "12/01/2026",
    stato: "pai_completato",
    medicoRichiedente: "Dr. Massimo Bruno",
    note: "Deterioramento cognitivo progressivo. Necessita supervisione continua, somministrazione insulina e supporto igiene.",
    mmg: "Dr.ssa Paola Rinaldi",
    medicoAssegnato: "Dr. Marco Vitale",
    dataVisitaUVMD: "15/01/2026",
    paiCompletato: true,
    dataPAI: "16/01/2026",
  },
  {
    id: 8,
    nome: "Marco",
    cognome: "Ricci",
    codiceFiscale: "RCCMRC45E28H501Z",
    dataNascita: "28/05/1945",
    eta: 80,
    sesso: "M",
    indirizzo: "Via Tiburtina 234, 00159 Roma",
    comune: "Roma",
    cap: "00159",
    distretto: "ASL Roma 2 - Distretto 5",
    telefono: "+39 06 1472583",
    email: "m.ricci@email.it",
    diagnosiPrincipale: "Ulcere da decubito stadio III (ICD-9: 707.03)",
    diagnosiSecondaria: "Paraplegia (ICD-9: 344.1)",
    condizione: "Non Autosufficiente",
    caregiver: {
      presente: true,
      nome: "Teresa Ricci",
      relazione: "Moglie",
      telefono: "+39 335 1472583",
      coabitante: true,
    },
    priorita: "alta",
    prioritaLabel: "U-A (Alta - Entro 24h)",
    provenienza: "Ospedale S. Camillo",
    dataRichiesta: "11/01/2026",
    stato: "assegnazione",
    medicoRichiedente: "Dr. Giorgio Martini",
    note: "Paziente allettato con lesioni da pressione multiple. Medicazioni avanzate quotidiane, cambio postura, nutrizione enterale.",
    mmg: "Dr. Andrea Gallo",
    medicoAssegnato: "Dr.ssa Elena Moretti",
    dataVisitaUVMD: "13/01/2026",
    paiCompletato: true,
    dataPAI: "14/01/2026",
    processTimeline: {
      richiesta: { data: "11/01/2026", completato: true },
      valutazione: { data: "13/01/2026", completato: true, giorni: 2 },
      pai: { data: "14/01/2026", completato: true, giorni: 1 },
      assegnazione: { data: null, completato: false, giorni: 3 },
      attivazione: { data: null, completato: false, giorni: null },
    },
  },
  {
    id: 9,
    nome: "Teresa",
    cognome: "Marchetti",
    codiceFiscale: "MRCTRS52C45H501P",
    dataNascita: "05/03/1952",
    eta: 73,
    sesso: "F",
    indirizzo: "Via Nomentana 156, 00162 Roma",
    comune: "Roma",
    cap: "00162",
    distretto: "ASL Roma 1 - Distretto 2",
    telefono: "+39 06 4425781",
    email: "t.marchetti@email.it",
    diagnosiPrincipale: "Artrosi grave bilaterale ginocchio (ICD-9: 715.16)",
    diagnosiSecondaria: "Obesita (ICD-9: 278.00)",
    condizione: "Parzialmente Autosufficiente",
    caregiver: { presente: true, nome: "Giovanni Marchetti", relazione: "Marito", telefono: "+39 331 4425781", coabitante: true },
    priorita: "bassa",
    prioritaLabel: "U-C (Bassa - Entro 10gg)",
    provenienza: "PUA",
    dataRichiesta: "18/01/2026",
    stato: "da_accettare",
    medicoRichiedente: "Dr.ssa Carla Amato",
    note: "Difficolta deambulatorie severe. Necessita fisioterapia domiciliare e supporto OSS.",
    mmg: "Dr. Franco Cattaneo",
  },
  {
    id: 10,
    nome: "Roberto",
    cognome: "Santini",
    codiceFiscale: "SNTRRT47H22F205K",
    dataNascita: "22/06/1947",
    eta: 78,
    sesso: "M",
    indirizzo: "Largo Preneste 33, 00176 Roma",
    comune: "Roma",
    cap: "00176",
    distretto: "ASL Roma 2 - Distretto 6",
    telefono: "+39 06 2789456",
    email: "",
    diagnosiPrincipale: "Insufficienza renale cronica stadio IV (ICD-9: 585.4)",
    diagnosiSecondaria: "Anemia secondaria (ICD-9: 285.21)",
    condizione: "Non Autosufficiente",
    caregiver: { presente: true, nome: "Carla Santini", relazione: "Moglie", telefono: "+39 348 2789456", coabitante: true },
    priorita: "alta",
    prioritaLabel: "U-A (Alta - Entro 24h)",
    provenienza: "Ospedale S. Eugenio",
    dataRichiesta: "19/01/2026",
    stato: "da_accettare",
    medicoRichiedente: "Dr. Enrico Palmieri",
    note: "Dialisi peritoneale domiciliare. Monitoraggio funzionalita renale e terapia eritropoietina.",
    mmg: "Dr.ssa Giovanna Basile",
  },
  {
    id: 11,
    nome: "Lucia",
    cognome: "Conti",
    codiceFiscale: "CNTLCU40A63H501V",
    dataNascita: "23/01/1940",
    eta: 86,
    sesso: "F",
    indirizzo: "Via Cassia 890, 00189 Roma",
    comune: "Roma",
    cap: "00189",
    distretto: "ASL Roma 1 - Distretto 1",
    telefono: "+39 06 3356721",
    email: "",
    diagnosiPrincipale: "Morbo di Parkinson (ICD-9: 332.0)",
    diagnosiSecondaria: "Disfagia orofaringea (ICD-9: 787.22)",
    condizione: "Non Autosufficiente",
    caregiver: { presente: true, nome: "Andrea Conti", relazione: "Figlio", telefono: "+39 336 3356721", coabitante: false },
    priorita: "media",
    prioritaLabel: "U-B (Media - Entro 72h)",
    provenienza: "PUA",
    dataRichiesta: "10/01/2026",
    stato: "presa_in_carico",
    medicoRichiedente: "Dr. Vittorio Leone",
    note: "Tremore invalidante, rischio cadute. Logopedia per disfagia e fisioterapia.",
    mmg: "Dr.ssa Elisa Fontana",
    medicoAssegnato: "Dr.ssa Sofia Gatti",
    dataVisitaUVMD: "14/01/2026",
  },
  {
    id: 12,
    nome: "Giorgio",
    cognome: "Pellegrini",
    codiceFiscale: "PLLGRG44M18F205Q",
    dataNascita: "18/08/1944",
    eta: 81,
    sesso: "M",
    indirizzo: "Via Flaminia 445, 00191 Roma",
    comune: "Roma",
    cap: "00191",
    distretto: "ASL Roma 1 - Distretto 1",
    telefono: "+39 06 8812345",
    email: "g.pellegrini@email.it",
    diagnosiPrincipale: "Scompenso cardiaco cronico (ICD-9: 428.22)",
    diagnosiSecondaria: "BPCO moderata (ICD-9: 491.20)",
    condizione: "Parzialmente Autosufficiente",
    caregiver: { presente: true, nome: "Marta Pellegrini", relazione: "Figlia", telefono: "+39 342 8812345", coabitante: false },
    priorita: "media",
    prioritaLabel: "U-B (Media - Entro 72h)",
    provenienza: "Ospedale S. Spirito",
    dataRichiesta: "16/01/2026",
    stato: "da_accettare",
    medicoRichiedente: "Dr.ssa Silvia Mazza",
    note: "Dimissione protetta. Monitoraggio scompenso, ossigenoterapia notturna, educazione terapeutica.",
    mmg: "Dr. Alberto Ferraro",
  },
  {
    id: 13,
    nome: "Paola",
    cognome: "De Luca",
    codiceFiscale: "DLCPLA56S58A662N",
    dataNascita: "18/11/1956",
    eta: 69,
    sesso: "F",
    indirizzo: "Via Aurelia 234, 00165 Roma",
    comune: "Roma",
    cap: "00165",
    distretto: "ASL Roma 3 - Distretto 13",
    telefono: "+39 06 6641239",
    email: "p.deluca@email.it",
    diagnosiPrincipale: "Neoplasia mammaria in chemioterapia (ICD-9: 174.9)",
    diagnosiSecondaria: "Neutropenia iatrogena (ICD-9: 288.00)",
    condizione: "Parzialmente Autosufficiente",
    caregiver: { presente: true, nome: "Marco De Luca", relazione: "Marito", telefono: "+39 339 6641239", coabitante: true },
    priorita: "alta",
    prioritaLabel: "U-A (Alta - Entro 24h)",
    provenienza: "Ospedale Gemelli",
    dataRichiesta: "20/01/2026",
    stato: "da_accettare",
    medicoRichiedente: "Dr.ssa Federica Galli",
    note: "Ciclo chemioterapico in corso. Prelievi settimanali, gestione PICC, supporto nutrizionale.",
    mmg: "Dr. Luca Morandi",
  },
  {
    id: 14,
    nome: "Salvatore",
    cognome: "Bruno",
    codiceFiscale: "BRNSVT38L12H501E",
    dataNascita: "12/07/1938",
    eta: 87,
    sesso: "M",
    indirizzo: "Viale Marconi 78, 00146 Roma",
    comune: "Roma",
    cap: "00146",
    distretto: "ASL Roma 3 - Distretto 11",
    telefono: "+39 06 5567432",
    email: "",
    diagnosiPrincipale: "Vasculopatia cerebrale cronica (ICD-9: 437.0)",
    diagnosiSecondaria: "Incontinenza urinaria (ICD-9: 788.30)",
    condizione: "Non Autosufficiente",
    caregiver: { presente: true, nome: "Rosa Bruno", relazione: "Moglie", telefono: "+39 345 5567432", coabitante: true },
    priorita: "bassa",
    prioritaLabel: "U-C (Bassa - Entro 10gg)",
    provenienza: "PUA",
    dataRichiesta: "08/01/2026",
    stato: "in_valutazione",
    medicoRichiedente: "Dr. Domenico Serra",
    note: "Decadimento cognitivo progressivo. Necessita OSS quotidiano, gestione incontinenza.",
    mmg: "Dr.ssa Anna Coppola",
    medicoAssegnato: "Dr. Roberto Santoro",
    dataVisitaUVMD: "12/01/2026",
  },
  {
    id: 15,
    nome: "Carmela",
    cognome: "Ferraro",
    codiceFiscale: "FRRCML49D55F839W",
    dataNascita: "15/04/1949",
    eta: 76,
    sesso: "F",
    indirizzo: "Via Cristoforo Colombo 440, 00145 Roma",
    comune: "Roma",
    cap: "00145",
    distretto: "ASL Roma 2 - Distretto 9",
    telefono: "+39 06 5129876",
    email: "c.ferraro@email.it",
    diagnosiPrincipale: "Sclerosi Multipla progressiva (ICD-9: 340)",
    diagnosiSecondaria: "Spasticita arti inferiori (ICD-9: 781.0)",
    condizione: "Non Autosufficiente",
    caregiver: { presente: true, nome: "Alessia Ferraro", relazione: "Figlia", telefono: "+39 334 5129876", coabitante: true },
    priorita: "alta",
    prioritaLabel: "U-A (Alta - Entro 24h)",
    provenienza: "Ospedale S. Camillo",
    dataRichiesta: "19/01/2026",
    stato: "presa_in_carico",
    medicoRichiedente: "Dr.ssa Ilaria Costa",
    note: "Grave disabilita motoria. Fisioterapia intensiva, prevenzione lesioni, gestione spasticita.",
    mmg: "Dr. Nicola Russo",
    medicoAssegnato: "Dr.ssa Elena Moretti",
    dataVisitaUVMD: "22/01/2026",
  },
  /* ═══ GENERATED PATIENTS (16-48) ═══ */
  {
    id: 16, nome: "Vittorio", cognome: "Mancini", codiceFiscale: "MNCVTR42A12H501R",
    dataNascita: "12/01/1942", eta: 84, sesso: "M",
    indirizzo: "Via della Conciliazione 20, 00193 Roma", comune: "Roma", cap: "00193",
    distretto: "ASL Roma 1 - Distretto 1", telefono: "+39 06 4451234", email: "",
    diagnosiPrincipale: "Fibrosi polmonare idiopatica (ICD-9: 516.31)",
    diagnosiSecondaria: "Ipertensione polmonare (ICD-9: 416.0)",
    condizione: "Non Autosufficiente",
    caregiver: { presente: true, nome: "Giovanna Mancini", relazione: "Moglie", telefono: "+39 338 4451234", coabitante: true },
    priorita: "alta", prioritaLabel: "U-A (Alta - Entro 24h)", provenienza: "Ospedale Gemelli",
    dataRichiesta: "21/01/2026", stato: "da_accettare",
    medicoRichiedente: "Dr. Emanuele Fabbri", note: "Ossigenoterapia continua, monitoraggio saturazione.", mmg: "Dr. Piero Galli",
  },
  {
    id: 17, nome: "Adriana", cognome: "Greco", codiceFiscale: "GRCDRN47H55F205A",
    dataNascita: "15/06/1947", eta: 78, sesso: "F",
    indirizzo: "Viale Trastevere 180, 00153 Roma", comune: "Roma", cap: "00153",
    distretto: "ASL Roma 3 - Distretto 12", telefono: "+39 06 5812347", email: "a.greco@email.it",
    diagnosiPrincipale: "Artrite reumatoide (ICD-9: 714.0)",
    diagnosiSecondaria: "Osteoporosi severa (ICD-9: 733.01)",
    condizione: "Parzialmente Autosufficiente",
    caregiver: { presente: true, nome: "Stefania Greco", relazione: "Figlia", telefono: "+39 347 5812347", coabitante: false },
    priorita: "media", prioritaLabel: "U-B (Media - Entro 72h)", provenienza: "PUA",
    dataRichiesta: "22/01/2026", stato: "da_accettare",
    medicoRichiedente: "Dr.ssa Roberta Monti", note: "Fisioterapia domiciliare, gestione dolore articolare.", mmg: "Dr.ssa Teresa Amato",
  },
  {
    id: 18, nome: "Ennio", cognome: "Lombardi", codiceFiscale: "LMBNN039S15H501P",
    dataNascita: "15/11/1939", eta: 86, sesso: "M",
    indirizzo: "Via Cassia 1200, 00189 Roma", comune: "Roma", cap: "00189",
    distretto: "ASL Roma 1 - Distretto 1", telefono: "+39 06 3312456", email: "",
    diagnosiPrincipale: "Encefalopatia vascolare cronica (ICD-9: 437.1)",
    diagnosiSecondaria: "Epilessia secondaria (ICD-9: 345.10)",
    condizione: "Non Autosufficiente",
    caregiver: { presente: true, nome: "Rita Lombardi", relazione: "Moglie", telefono: "+39 333 3312456", coabitante: true },
    priorita: "alta", prioritaLabel: "U-A (Alta - Entro 24h)", provenienza: "Ospedale S. Andrea",
    dataRichiesta: "23/01/2026", stato: "da_accettare",
    medicoRichiedente: "Dr. Francesco Vitali", note: "Crisi epilettiche frequenti, necessita sorveglianza continua.", mmg: "Dr. Carlo Rinaldi",
  },
  {
    id: 19, nome: "Silvana", cognome: "Costa", codiceFiscale: "CSTSVN50D63F205B",
    dataNascita: "23/04/1950", eta: 75, sesso: "F",
    indirizzo: "Via Appia Antica 88, 00179 Roma", comune: "Roma", cap: "00179",
    distretto: "ASL Roma 2 - Distretto 5", telefono: "+39 06 7128934", email: "s.costa@email.it",
    diagnosiPrincipale: "Insufficienza venosa cronica (ICD-9: 459.81)",
    diagnosiSecondaria: "Ulcera venosa bilaterale (ICD-9: 454.0)",
    condizione: "Parzialmente Autosufficiente",
    caregiver: { presente: false, nome: "", relazione: "", telefono: "", coabitante: false },
    priorita: "bassa", prioritaLabel: "U-C (Bassa - Entro 10gg)", provenienza: "PUA",
    dataRichiesta: "24/01/2026", stato: "da_accettare",
    medicoRichiedente: "Dr.ssa Marta Sorrentino", note: "Medicazioni arti inferiori, elastocompressione.", mmg: "Dr. Luigi Barbieri",
  },
  {
    id: 20, nome: "Alfredo", cognome: "Moretti", codiceFiscale: "MRTLFD44B28H501N",
    dataNascita: "28/02/1944", eta: 81, sesso: "M",
    indirizzo: "Via dei Fori Imperiali 35, 00186 Roma", comune: "Roma", cap: "00186",
    distretto: "ASL Roma 1 - Distretto 2", telefono: "+39 06 6923478", email: "",
    diagnosiPrincipale: "Diabete Mellito Tipo 2 complicato (ICD-9: 250.70)",
    diagnosiSecondaria: "Retinopatia diabetica (ICD-9: 362.01)",
    condizione: "Parzialmente Autosufficiente",
    caregiver: { presente: true, nome: "Carla Moretti", relazione: "Moglie", telefono: "+39 340 6923478", coabitante: true },
    priorita: "media", prioritaLabel: "U-B (Media - Entro 72h)", provenienza: "PUA",
    dataRichiesta: "25/01/2026", stato: "presa_in_carico",
    medicoRichiedente: "Dr. Gianluca Ferretti", note: "Monitoraggio glicemico, iniezioni insulina, cura piede diabetico.", mmg: "Dr.ssa Daniela Palmieri",
    medicoAssegnato: "Dr.ssa Sofia Gatti", dataVisitaUVMD: "28/01/2026",
  },
  {
    id: 21, nome: "Concetta", cognome: "Rizzo", codiceFiscale: "RZZCNC41L55A662D",
    dataNascita: "15/07/1941", eta: 84, sesso: "F",
    indirizzo: "Via Labicana 78, 00184 Roma", comune: "Roma", cap: "00184",
    distretto: "ASL Roma 2 - Distretto 6", telefono: "+39 06 2245671", email: "",
    diagnosiPrincipale: "Scompenso cardiaco stadio III (ICD-9: 428.23)",
    diagnosiSecondaria: "Insufficienza mitralica severa (ICD-9: 424.0)",
    condizione: "Non Autosufficiente",
    caregiver: { presente: true, nome: "Angelo Rizzo", relazione: "Figlio", telefono: "+39 336 2245671", coabitante: true },
    priorita: "alta", prioritaLabel: "U-A (Alta - Entro 24h)", provenienza: "Ospedale S. Giovanni",
    dataRichiesta: "26/01/2026", stato: "da_accettare",
    medicoRichiedente: "Dr.ssa Valeria Longo", note: "Terapia diuretica endovenosa, monitoraggio peso e bilancio idrico.", mmg: "Dr. Massimiliano Cattaneo",
  },
  {
    id: 22, nome: "Piero", cognome: "Fontana", codiceFiscale: "FNTPRI46C18F839E",
    dataNascita: "18/03/1946", eta: 79, sesso: "M",
    indirizzo: "Via Gregorio VII 145, 00165 Roma", comune: "Roma", cap: "00165",
    distretto: "ASL Roma 3 - Distretto 13", telefono: "+39 06 3928174", email: "p.fontana@email.it",
    diagnosiPrincipale: "Neoplasia prostatica metastatica (ICD-9: 185)",
    diagnosiSecondaria: "Dolore oncologico cronico (ICD-9: 338.3)",
    condizione: "Non Autosufficiente",
    caregiver: { presente: true, nome: "Laura Fontana", relazione: "Moglie", telefono: "+39 349 3928174", coabitante: true },
    priorita: "alta", prioritaLabel: "U-A (Alta - Entro 24h)", provenienza: "Ospedale Gemelli",
    dataRichiesta: "27/01/2026", stato: "presa_in_carico",
    medicoRichiedente: "Dr. Claudio De Santis", note: "Cure palliative, gestione dolore con pompa infusionale.", mmg: "Dr. Fabio Serra",
    medicoAssegnato: "Dr. Roberto Santoro", dataVisitaUVMD: "29/01/2026",
  },
  {
    id: 23, nome: "Rita", cognome: "Cattaneo", codiceFiscale: "CTTRTA53H48H501G",
    dataNascita: "08/06/1953", eta: 72, sesso: "F",
    indirizzo: "Viale Liegi 42, 00198 Roma", comune: "Roma", cap: "00198",
    distretto: "ASL Roma 1 - Distretto 2", telefono: "+39 06 8417293", email: "r.cattaneo@email.it",
    diagnosiPrincipale: "Sclerosi laterale amiotrofica (ICD-9: 335.20)",
    diagnosiSecondaria: "Disfagia neurogena (ICD-9: 787.20)",
    condizione: "Non Autosufficiente",
    caregiver: { presente: true, nome: "Enrico Cattaneo", relazione: "Marito", telefono: "+39 335 8417293", coabitante: true },
    priorita: "alta", prioritaLabel: "U-A (Alta - Entro 24h)", provenienza: "Ospedale Tor Vergata",
    dataRichiesta: "28/01/2026", stato: "da_accettare",
    medicoRichiedente: "Dr.ssa Simona Caruso", note: "Ventilazione assistita, PEG, fisioterapia respiratoria.", mmg: "Dr. Giovanni Basile",
  },
  {
    id: 24, nome: "Renato", cognome: "Barbieri", codiceFiscale: "BRBRNT48M12H501T",
    dataNascita: "12/08/1948", eta: 77, sesso: "M",
    indirizzo: "Via Salaria 890, 00198 Roma", comune: "Roma", cap: "00198",
    distretto: "ASL Roma 1 - Distretto 2", telefono: "+39 06 4578123", email: "",
    diagnosiPrincipale: "Frattura vertebrale osteoporotica (ICD-9: 733.13)",
    diagnosiSecondaria: "Stenosi del canale lombare (ICD-9: 724.02)",
    condizione: "Parzialmente Autosufficiente",
    caregiver: { presente: true, nome: "Maria Barbieri", relazione: "Moglie", telefono: "+39 338 4578123", coabitante: true },
    priorita: "bassa", prioritaLabel: "U-C (Bassa - Entro 10gg)", provenienza: "PUA",
    dataRichiesta: "29/01/2026", stato: "da_accettare",
    medicoRichiedente: "Dr. Davide Martini", note: "Busto ortopedico, riabilitazione posturale.", mmg: "Dr.ssa Francesca Coppola",
  },
  {
    id: 25, nome: "Grazia", cognome: "Sorrentino", codiceFiscale: "SRRGRZ45T65F205C",
    dataNascita: "25/12/1945", eta: 80, sesso: "F",
    indirizzo: "Via Ostiense 340, 00146 Roma", comune: "Roma", cap: "00146",
    distretto: "ASL Roma 3 - Distretto 11", telefono: "+39 06 5781234", email: "",
    diagnosiPrincipale: "Demenza vascolare (ICD-9: 290.40)",
    diagnosiSecondaria: "Ipertensione arteriosa stadio 3 (ICD-9: 401.1)",
    condizione: "Non Autosufficiente",
    caregiver: { presente: true, nome: "Patrizia Sorrentino", relazione: "Figlia", telefono: "+39 347 5781234", coabitante: false },
    priorita: "media", prioritaLabel: "U-B (Media - Entro 72h)", provenienza: "PUA",
    dataRichiesta: "30/01/2026", stato: "presa_in_carico",
    medicoRichiedente: "Dr.ssa Lucia Pellegrini", note: "Sorveglianza continua, terapia antipertensiva, OSS.", mmg: "Dr. Roberto Conti",
    medicoAssegnato: "Dr. Marco Vitale", dataVisitaUVMD: "02/02/2026",
  },
  {
    id: 26, nome: "Vincenzo", cognome: "De Rosa", codiceFiscale: "DRSVNC43D15H501F",
    dataNascita: "15/04/1943", eta: 82, sesso: "M",
    indirizzo: "Via Aurelia Antica 200, 00165 Roma", comune: "Roma", cap: "00165",
    distretto: "ASL Roma 3 - Distretto 13", telefono: "+39 06 6634578", email: "",
    diagnosiPrincipale: "BPCO severa con riacutizzazioni (ICD-9: 491.22)",
    diagnosiSecondaria: "Cuore polmonare cronico (ICD-9: 416.9)",
    condizione: "Non Autosufficiente",
    caregiver: { presente: true, nome: "Rosa De Rosa", relazione: "Moglie", telefono: "+39 340 6634578", coabitante: true },
    priorita: "alta", prioritaLabel: "U-A (Alta - Entro 24h)", provenienza: "Ospedale S. Camillo",
    dataRichiesta: "31/01/2026", stato: "da_accettare",
    medicoRichiedente: "Dr. Nicola Amato", note: "Ventilazione non invasiva notturna, aerosolterapia.", mmg: "Dr.ssa Silvia Leone",
  },
  {
    id: 27, nome: "Assunta", cognome: "Galli", codiceFiscale: "GLLSNT51A62A662H",
    dataNascita: "22/01/1951", eta: 75, sesso: "F",
    indirizzo: "Via Casilina 1100, 00169 Roma", comune: "Roma", cap: "00169",
    distretto: "ASL Roma 2 - Distretto 7", telefono: "+39 06 2398714", email: "a.galli@email.it",
    diagnosiPrincipale: "Insufficienza cardiaca diastolica (ICD-9: 428.30)",
    diagnosiSecondaria: "Anemia cronica (ICD-9: 285.9)",
    condizione: "Parzialmente Autosufficiente",
    caregiver: { presente: true, nome: "Dario Galli", relazione: "Marito", telefono: "+39 333 2398714", coabitante: true },
    priorita: "media", prioritaLabel: "U-B (Media - Entro 72h)", provenienza: "Ospedale Tor Vergata",
    dataRichiesta: "01/02/2026", stato: "da_accettare",
    medicoRichiedente: "Dr.ssa Angela Ferraro", note: "Monitoraggio emocromo, trasfusioni periodiche.", mmg: "Dr. Guido Marchetti",
  },
  {
    id: 28, nome: "Bruno", cognome: "Amato", codiceFiscale: "MTABRN40H15F205J",
    dataNascita: "15/06/1940", eta: 85, sesso: "M",
    indirizzo: "Via Portuense 600, 00149 Roma", comune: "Roma", cap: "00149",
    distretto: "ASL Roma 3 - Distretto 11", telefono: "+39 06 5598712", email: "",
    diagnosiPrincipale: "Neoplasia polmonare stadio IV (ICD-9: 162.9)",
    diagnosiSecondaria: "Versamento pleurico maligno (ICD-9: 511.81)",
    condizione: "Non Autosufficiente",
    caregiver: { presente: true, nome: "Carmela Amato", relazione: "Moglie", telefono: "+39 349 5598712", coabitante: true },
    priorita: "alta", prioritaLabel: "U-A (Alta - Entro 24h)", provenienza: "Ospedale S. Camillo",
    dataRichiesta: "02/02/2026", stato: "presa_in_carico",
    medicoRichiedente: "Dr. Stefano Mazza", note: "Cure palliative domiciliari, gestione dispnea.", mmg: "Dr.ssa Antonella Ricci",
    medicoAssegnato: "Dr.ssa Elena Moretti", dataVisitaUVMD: "04/02/2026",
  },
  {
    id: 29, nome: "Giuseppina", cognome: "Serra", codiceFiscale: "SRRGPP46M62H501L",
    dataNascita: "22/08/1946", eta: 79, sesso: "F",
    indirizzo: "Via Tiburtina 1020, 00156 Roma", comune: "Roma", cap: "00156",
    distretto: "ASL Roma 2 - Distretto 5", telefono: "+39 06 4128793", email: "",
    diagnosiPrincipale: "Ictus emorragico (ICD-9: 431)",
    diagnosiSecondaria: "Afasia motoria (ICD-9: 784.3)",
    condizione: "Non Autosufficiente",
    caregiver: { presente: true, nome: "Fabio Serra", relazione: "Figlio", telefono: "+39 336 4128793", coabitante: true },
    priorita: "alta", prioritaLabel: "U-A (Alta - Entro 24h)", provenienza: "Ospedale Pertini",
    dataRichiesta: "03/02/2026", stato: "da_accettare",
    medicoRichiedente: "Dr.ssa Paola Gentile", note: "Riabilitazione neuromotoria intensiva, logopedia.", mmg: "Dr. Eugenio Colombo",
  },
  {
    id: 30, nome: "Ottavio", cognome: "Vitale", codiceFiscale: "VTLTTV37L22F839G",
    dataNascita: "22/07/1937", eta: 88, sesso: "M",
    indirizzo: "Via Prenestina 1500, 00155 Roma", comune: "Roma", cap: "00155",
    distretto: "ASL Roma 2 - Distretto 7", telefono: "+39 06 2178345", email: "",
    diagnosiPrincipale: "Parkinsonismo atipico (ICD-9: 332.1)",
    diagnosiSecondaria: "Disfagia orofaringea (ICD-9: 787.22)",
    condizione: "Non Autosufficiente",
    caregiver: { presente: true, nome: "Anna Vitale", relazione: "Figlia", telefono: "+39 345 2178345", coabitante: false },
    priorita: "media", prioritaLabel: "U-B (Media - Entro 72h)", provenienza: "PUA",
    dataRichiesta: "03/02/2026", stato: "presa_in_carico",
    medicoRichiedente: "Dr. Alessandro Ferretti", note: "Fisioterapia, logopedia, gestione farmacologica.", mmg: "Dr.ssa Claudia Monti",
    medicoAssegnato: "Dr.ssa Sofia Gatti", dataVisitaUVMD: "06/02/2026",
  },
  {
    id: 31, nome: "Filomena", cognome: "Caruso", codiceFiscale: "CRSFMN44S55A662K",
    dataNascita: "15/11/1944", eta: 81, sesso: "F",
    indirizzo: "Via Nomentana 500, 00141 Roma", comune: "Roma", cap: "00141",
    distretto: "ASL Roma 1 - Distretto 3", telefono: "+39 06 8234567", email: "",
    diagnosiPrincipale: "Frattura periprotesica anca (ICD-9: 996.44)",
    diagnosiSecondaria: "Anemia post-chirurgica (ICD-9: 285.1)",
    condizione: "Non Autosufficiente",
    caregiver: { presente: true, nome: "Giuseppe Caruso", relazione: "Marito", telefono: "+39 338 8234567", coabitante: true },
    priorita: "bassa", prioritaLabel: "U-C (Bassa - Entro 10gg)", provenienza: "Ospedale S. Andrea",
    dataRichiesta: "04/02/2026", stato: "da_accettare",
    medicoRichiedente: "Dr.ssa Elisa Santoro", note: "Riabilitazione post-operatoria, profilassi TVP.", mmg: "Dr. Marco Pellegrini",
  },
  {
    id: 32, nome: "Domenico", cognome: "Longo", codiceFiscale: "LNGDNC52E15H501S",
    dataNascita: "15/05/1952", eta: 73, sesso: "M",
    indirizzo: "Via Tuscolana 1200, 00174 Roma", comune: "Roma", cap: "00174",
    distretto: "ASL Roma 2 - Distretto 6", telefono: "+39 06 7198234", email: "d.longo@email.it",
    diagnosiPrincipale: "Cirrosi epatica scompensata (ICD-9: 571.5)",
    diagnosiSecondaria: "Ascite (ICD-9: 789.59)",
    condizione: "Non Autosufficiente",
    caregiver: { presente: true, nome: "Teresa Longo", relazione: "Moglie", telefono: "+39 347 7198234", coabitante: true },
    priorita: "alta", prioritaLabel: "U-A (Alta - Entro 24h)", provenienza: "Ospedale S. Eugenio",
    dataRichiesta: "05/02/2026", stato: "da_accettare",
    medicoRichiedente: "Dr. Raffaele Bruno", note: "Paracentesi periodiche, dieta iposodica, monitoraggio epatico.", mmg: "Dr.ssa Alessia Fontana",
  },
  {
    id: 33, nome: "Rosaria", cognome: "Martinelli", codiceFiscale: "MRTRSR49D55F205M",
    dataNascita: "15/04/1949", eta: 76, sesso: "F",
    indirizzo: "Via della Magliana 250, 00148 Roma", comune: "Roma", cap: "00148",
    distretto: "ASL Roma 3 - Distretto 11", telefono: "+39 06 5541298", email: "",
    diagnosiPrincipale: "Neuropatia periferica (ICD-9: 356.9)",
    diagnosiSecondaria: "Diabete Mellito Tipo 2 (ICD-9: 250.00)",
    condizione: "Parzialmente Autosufficiente",
    caregiver: { presente: true, nome: "Franco Martinelli", relazione: "Marito", telefono: "+39 340 5541298", coabitante: true },
    priorita: "bassa", prioritaLabel: "U-C (Bassa - Entro 10gg)", provenienza: "PUA",
    dataRichiesta: "05/02/2026", stato: "presa_in_carico",
    medicoRichiedente: "Dr.ssa Giovanna Greco", note: "Fisioterapia, prevenzione cadute, gestione diabete.", mmg: "Dr. Sandro Costa",
    medicoAssegnato: "Dr. Marco Vitale", dataVisitaUVMD: "08/02/2026",
  },
  {
    id: 34, nome: "Angelo", cognome: "Gentile", codiceFiscale: "GNTNGL38S12H501U",
    dataNascita: "12/11/1938", eta: 87, sesso: "M",
    indirizzo: "Via Casilina 2100, 00169 Roma", comune: "Roma", cap: "00169",
    distretto: "ASL Roma 2 - Distretto 7", telefono: "+39 06 2341589", email: "",
    diagnosiPrincipale: "Malattia di Alzheimer moderata (ICD-9: 331.0)",
    diagnosiSecondaria: "Incontinenza mista (ICD-9: 788.33)",
    condizione: "Non Autosufficiente",
    caregiver: { presente: true, nome: "Lucia Gentile", relazione: "Figlia", telefono: "+39 333 2341589", coabitante: true },
    priorita: "media", prioritaLabel: "U-B (Media - Entro 72h)", provenienza: "PUA",
    dataRichiesta: "06/02/2026", stato: "da_accettare",
    medicoRichiedente: "Dr. Valerio Santini", note: "Supporto cognitivo, OSS quotidiano, gestione incontinenza.", mmg: "Dr.ssa Sabrina Rizzo",
  },
  {
    id: 35, nome: "Antonietta", cognome: "Palumbo", codiceFiscale: "PLMNTN47H55A662Q",
    dataNascita: "15/06/1947", eta: 78, sesso: "F",
    indirizzo: "Via Appia Nuova 1500, 00178 Roma", comune: "Roma", cap: "00178",
    distretto: "ASL Roma 2 - Distretto 9", telefono: "+39 06 7834512", email: "a.palumbo@email.it",
    diagnosiPrincipale: "Insufficienza cardiaca con FE ridotta (ICD-9: 428.20)",
    diagnosiSecondaria: "Diabete Mellito Tipo 2 (ICD-9: 250.00)",
    condizione: "Parzialmente Autosufficiente",
    caregiver: { presente: false, nome: "", relazione: "", telefono: "", coabitante: false },
    priorita: "media", prioritaLabel: "U-B (Media - Entro 72h)", provenienza: "Ospedale Tor Vergata",
    dataRichiesta: "07/02/2026", stato: "da_accettare",
    medicoRichiedente: "Dr.ssa Cristina Martinelli", note: "Vive sola, monitoraggio telematico, attivazione servizi sociali.", mmg: "Dr. Andrea Ferraro",
  },
  {
    id: 36, nome: "Renzo", cognome: "Fabbri", codiceFiscale: "FBBRNZ43C28F839H",
    dataNascita: "28/03/1943", eta: 82, sesso: "M",
    indirizzo: "Via Olimpica 88, 00194 Roma", comune: "Roma", cap: "00194",
    distretto: "ASL Roma 1 - Distretto 1", telefono: "+39 06 3298741", email: "",
    diagnosiPrincipale: "Mielofibrosi primaria (ICD-9: 238.76)",
    diagnosiSecondaria: "Splenomegalia (ICD-9: 789.2)",
    condizione: "Parzialmente Autosufficiente",
    caregiver: { presente: true, nome: "Maria Fabbri", relazione: "Moglie", telefono: "+39 349 3298741", coabitante: true },
    priorita: "alta", prioritaLabel: "U-A (Alta - Entro 24h)", provenienza: "Ospedale Gemelli",
    dataRichiesta: "08/02/2026", stato: "da_accettare",
    medicoRichiedente: "Dr. Lorenzo Palmieri", note: "Prelievi bisettimanali, trasfusioni periodiche.", mmg: "Dr.ssa Roberta Galli",
  },
  {
    id: 37, nome: "Immacolata", cognome: "Leone", codiceFiscale: "LNIMMCL50T55H501W",
    dataNascita: "15/12/1950", eta: 75, sesso: "F",
    indirizzo: "Via Casal del Marmo 120, 00135 Roma", comune: "Roma", cap: "00135",
    distretto: "ASL Roma 1 - Distretto 1", telefono: "+39 06 3587412", email: "",
    diagnosiPrincipale: "Esiti amputazione transtibiale sinistra (ICD-9: V49.75)",
    diagnosiSecondaria: "Arteriopatia obliterante periferica (ICD-9: 440.20)",
    condizione: "Non Autosufficiente",
    caregiver: { presente: true, nome: "Marco Leone", relazione: "Figlio", telefono: "+39 336 3587412", coabitante: true },
    priorita: "media", prioritaLabel: "U-B (Media - Entro 72h)", provenienza: "Ospedale S. Spirito",
    dataRichiesta: "09/02/2026", stato: "presa_in_carico",
    medicoRichiedente: "Dr.ssa Francesca De Luca", note: "Riabilitazione protesica, cura moncone, addestramento deambulazione.", mmg: "Dr. Paolo Longo",
    medicoAssegnato: "Dr. Roberto Santoro", dataVisitaUVMD: "11/02/2026",
  },
  {
    id: 38, nome: "Gennaro", cognome: "Rossetti", codiceFiscale: "RSSGNR41A15F205V",
    dataNascita: "15/01/1941", eta: 85, sesso: "M",
    indirizzo: "Via Ardeatina 300, 00178 Roma", comune: "Roma", cap: "00178",
    distretto: "ASL Roma 2 - Distretto 9", telefono: "+39 06 5123478", email: "",
    diagnosiPrincipale: "Carcinoma colon-rettale operato (ICD-9: 153.9)",
    diagnosiSecondaria: "Colostomia permanente (ICD-9: V44.3)",
    condizione: "Parzialmente Autosufficiente",
    caregiver: { presente: true, nome: "Anna Rossetti", relazione: "Moglie", telefono: "+39 345 5123478", coabitante: true },
    priorita: "bassa", prioritaLabel: "U-C (Bassa - Entro 10gg)", provenienza: "Ospedale S. Eugenio",
    dataRichiesta: "10/02/2026", stato: "da_accettare",
    medicoRichiedente: "Dr. Maurizio Gentile", note: "Gestione stomia, educazione paziente e caregiver.", mmg: "Dr.ssa Valentina Barbieri",
  },
  {
    id: 39, nome: "Emilia", cognome: "Monti", codiceFiscale: "MNTEML48L62H501X",
    dataNascita: "22/07/1948", eta: 77, sesso: "F",
    indirizzo: "Via Portuense 1200, 00148 Roma", comune: "Roma", cap: "00148",
    distretto: "ASL Roma 3 - Distretto 11", telefono: "+39 06 6598234", email: "e.monti@email.it",
    diagnosiPrincipale: "Insufficienza respiratoria cronica (ICD-9: 518.83)",
    diagnosiSecondaria: "Obesita grave (ICD-9: 278.01)",
    condizione: "Parzialmente Autosufficiente",
    caregiver: { presente: true, nome: "Paolo Monti", relazione: "Marito", telefono: "+39 340 6598234", coabitante: true },
    priorita: "media", prioritaLabel: "U-B (Media - Entro 72h)", provenienza: "PUA",
    dataRichiesta: "10/02/2026", stato: "da_accettare",
    medicoRichiedente: "Dr.ssa Rita Sorrentino", note: "Ossigenoterapia, fisioterapia respiratoria, supporto nutrizionale.", mmg: "Dr. Pietro Caruso",
  },
  {
    id: 40, nome: "Sergio", cognome: "Rinaldi", codiceFiscale: "RNLSRG45B18F839K",
    dataNascita: "18/02/1945", eta: 81, sesso: "M",
    indirizzo: "Via Laurentina 700, 00143 Roma", comune: "Roma", cap: "00143",
    distretto: "ASL Roma 2 - Distretto 9", telefono: "+39 06 5934128", email: "",
    diagnosiPrincipale: "Esiti ictus ischemico emisfero sinistro (ICD-9: 438.20)",
    diagnosiSecondaria: "Emiplegia destra (ICD-9: 342.90)",
    condizione: "Non Autosufficiente",
    caregiver: { presente: true, nome: "Claudia Rinaldi", relazione: "Moglie", telefono: "+39 333 5934128", coabitante: true },
    priorita: "alta", prioritaLabel: "U-A (Alta - Entro 24h)", provenienza: "Ospedale S. Camillo",
    dataRichiesta: "11/02/2026", stato: "da_accettare",
    medicoRichiedente: "Dr. Emanuele Pellegrini", note: "Riabilitazione neuromotoria, logopedia, OSS.", mmg: "Dr.ssa Maria Conti",
  },
  {
    id: 41, nome: "Margherita", cognome: "Ferretti", codiceFiscale: "FRRMRG52D62A662R",
    dataNascita: "22/04/1952", eta: 73, sesso: "F",
    indirizzo: "Via di Torrevecchia 400, 00168 Roma", comune: "Roma", cap: "00168",
    distretto: "ASL Roma 1 - Distretto 1", telefono: "+39 06 3012478", email: "m.ferretti@email.it",
    diagnosiPrincipale: "Lupus eritematoso sistemico (ICD-9: 710.0)",
    diagnosiSecondaria: "Nefrite lupica stadio IV (ICD-9: 583.81)",
    condizione: "Parzialmente Autosufficiente",
    caregiver: { presente: true, nome: "Roberto Ferretti", relazione: "Marito", telefono: "+39 347 3012478", coabitante: true },
    priorita: "media", prioritaLabel: "U-B (Media - Entro 72h)", provenienza: "Ospedale Gemelli",
    dataRichiesta: "12/02/2026", stato: "presa_in_carico",
    medicoRichiedente: "Dr.ssa Simona Fabbri", note: "Monitoraggio funzionalita renale, immunosoppressori.", mmg: "Dr. Vittorio Amato",
    medicoAssegnato: "Dr.ssa Sofia Gatti", dataVisitaUVMD: "14/02/2026",
  },
  {
    id: 42, nome: "Pasquale", cognome: "Coppola", codiceFiscale: "CPPPQL39H15H501Y",
    dataNascita: "15/06/1939", eta: 86, sesso: "M",
    indirizzo: "Viale Palmiro Togliatti 900, 00155 Roma", comune: "Roma", cap: "00155",
    distretto: "ASL Roma 2 - Distretto 7", telefono: "+39 06 2587413", email: "",
    diagnosiPrincipale: "Ulcere arteriose arti inferiori (ICD-9: 440.24)",
    diagnosiSecondaria: "Arteriopatia periferica stadio IV (ICD-9: 440.22)",
    condizione: "Non Autosufficiente",
    caregiver: { presente: true, nome: "Carmela Coppola", relazione: "Moglie", telefono: "+39 338 2587413", coabitante: true },
    priorita: "alta", prioritaLabel: "U-A (Alta - Entro 24h)", provenienza: "Ospedale Pertini",
    dataRichiesta: "13/02/2026", stato: "da_accettare",
    medicoRichiedente: "Dr. Salvatore Martini", note: "Medicazioni avanzate quotidiane, analgesia, valutazione chirurgica.", mmg: "Dr.ssa Linda Moretti",
  },
  {
    id: 43, nome: "Flora", cognome: "Bianchi", codiceFiscale: "BNCFLR47C62F205Z",
    dataNascita: "22/03/1947", eta: 78, sesso: "F",
    indirizzo: "Via Anagnina 500, 00173 Roma", comune: "Roma", cap: "00173",
    distretto: "ASL Roma 2 - Distretto 6", telefono: "+39 06 7293841", email: "",
    diagnosiPrincipale: "Sindrome da allettamento (ICD-9: 728.2)",
    diagnosiSecondaria: "Lesioni da decubito stadio II (ICD-9: 707.22)",
    condizione: "Non Autosufficiente",
    caregiver: { presente: true, nome: "Antonio Bianchi", relazione: "Figlio", telefono: "+39 336 7293841", coabitante: false },
    priorita: "bassa", prioritaLabel: "U-C (Bassa - Entro 10gg)", provenienza: "PUA",
    dataRichiesta: "13/02/2026", stato: "da_accettare",
    medicoRichiedente: "Dr.ssa Monica Vitale", note: "Prevenzione lesioni, mobilizzazione passiva, nutrizione.", mmg: "Dr. Giuseppe Ferraro",
  },
  {
    id: 44, nome: "Umberto", cognome: "Santoro", codiceFiscale: "SNTRBT42M12H501A",
    dataNascita: "12/08/1942", eta: 83, sesso: "M",
    indirizzo: "Via di Bravetta 200, 00164 Roma", comune: "Roma", cap: "00164",
    distretto: "ASL Roma 3 - Distretto 13", telefono: "+39 06 6641278", email: "",
    diagnosiPrincipale: "Insufficienza cardiaca refrattaria (ICD-9: 428.9)",
    diagnosiSecondaria: "Fibrillazione atriale permanente (ICD-9: 427.31)",
    condizione: "Non Autosufficiente",
    caregiver: { presente: true, nome: "Maria Santoro", relazione: "Moglie", telefono: "+39 349 6641278", coabitante: true },
    priorita: "alta", prioritaLabel: "U-A (Alta - Entro 24h)", provenienza: "Ospedale S. Spirito",
    dataRichiesta: "14/02/2026", stato: "da_accettare",
    medicoRichiedente: "Dr. Pietro Greco", note: "Terapia infusionale, monitoraggio ECG, bilancio idrico.", mmg: "Dr.ssa Paola Costa",
  },
  {
    id: 45, nome: "Adelaide", cognome: "Palmieri", codiceFiscale: "PLMDLD53L62A662E",
    dataNascita: "22/07/1953", eta: 72, sesso: "F",
    indirizzo: "Via delle Vigne Nuove 120, 00139 Roma", comune: "Roma", cap: "00139",
    distretto: "ASL Roma 1 - Distretto 3", telefono: "+39 06 8712345", email: "a.palmieri@email.it",
    diagnosiPrincipale: "Esiti mastectomia con linfedema (ICD-9: 457.0)",
    diagnosiSecondaria: "Sindrome depressiva reattiva (ICD-9: 309.0)",
    condizione: "Parzialmente Autosufficiente",
    caregiver: { presente: true, nome: "Franco Palmieri", relazione: "Marito", telefono: "+39 335 8712345", coabitante: true },
    priorita: "bassa", prioritaLabel: "U-C (Bassa - Entro 10gg)", provenienza: "PUA",
    dataRichiesta: "14/02/2026", stato: "presa_in_carico",
    medicoRichiedente: "Dr.ssa Eleonora Leone", note: "Linfodrenaggio, supporto psicologico.", mmg: "Dr. Claudio De Rosa",
    medicoAssegnato: "Dr. Marco Vitale", dataVisitaUVMD: "16/02/2026",
  },
  {
    id: 46, nome: "Oreste", cognome: "Basile", codiceFiscale: "BSLRST36D15F839L",
    dataNascita: "15/04/1936", eta: 89, sesso: "M",
    indirizzo: "Via Boccea 600, 00166 Roma", comune: "Roma", cap: "00166",
    distretto: "ASL Roma 1 - Distretto 1", telefono: "+39 06 6234789", email: "",
    diagnosiPrincipale: "Demenza senile avanzata (ICD-9: 290.0)",
    diagnosiSecondaria: "Disfagia severa (ICD-9: 787.24)",
    condizione: "Non Autosufficiente",
    caregiver: { presente: true, nome: "Paola Basile", relazione: "Figlia", telefono: "+39 340 6234789", coabitante: true },
    priorita: "media", prioritaLabel: "U-B (Media - Entro 72h)", provenienza: "PUA",
    dataRichiesta: "15/02/2026", stato: "da_accettare",
    medicoRichiedente: "Dr. Armando Cattaneo", note: "PEG in atto, sorveglianza continua, OSS h12.", mmg: "Dr.ssa Irene Lombardi",
  },
  {
    id: 47, nome: "Elvira", cognome: "De Santis", codiceFiscale: "DSNLVR44S62H501C",
    dataNascita: "22/11/1944", eta: 81, sesso: "F",
    indirizzo: "Via Salaria 1300, 00138 Roma", comune: "Roma", cap: "00138",
    distretto: "ASL Roma 1 - Distretto 3", telefono: "+39 06 8198234", email: "",
    diagnosiPrincipale: "Sindrome nefrosica (ICD-9: 581.9)",
    diagnosiSecondaria: "Edema generalizzato (ICD-9: 782.3)",
    condizione: "Parzialmente Autosufficiente",
    caregiver: { presente: true, nome: "Mario De Santis", relazione: "Marito", telefono: "+39 333 8198234", coabitante: true },
    priorita: "media", prioritaLabel: "U-B (Media - Entro 72h)", provenienza: "Ospedale S. Andrea",
    dataRichiesta: "15/02/2026", stato: "da_accettare",
    medicoRichiedente: "Dr.ssa Chiara Rossetti", note: "Monitoraggio proteinuria, terapia diuretica, dieta iposodica.", mmg: "Dr. Enrico Fabbri",
  },
  {
    id: 48, nome: "Aldo", cognome: "Ferrara", codiceFiscale: "FRRLDA40B12F205N",
    dataNascita: "12/02/1940", eta: 86, sesso: "M",
    indirizzo: "Via Flaminia Nuova 800, 00191 Roma", comune: "Roma", cap: "00191",
    distretto: "ASL Roma 1 - Distretto 1", telefono: "+39 06 3341289", email: "",
    diagnosiPrincipale: "Esiti politrauma con tetraparesi (ICD-9: 344.00)",
    diagnosiSecondaria: "Vescica neurologica (ICD-9: 596.54)",
    condizione: "Non Autosufficiente",
    caregiver: { presente: true, nome: "Giovanna Ferrara", relazione: "Moglie", telefono: "+39 349 3341289", coabitante: true },
    priorita: "alta", prioritaLabel: "U-A (Alta - Entro 24h)", provenienza: "Ospedale Gemelli",
    dataRichiesta: "16/02/2026", stato: "da_accettare",
    medicoRichiedente: "Dr. Giorgio Palumbo", note: "Cateterismo intermittente, prevenzione lesioni, FKT.", mmg: "Dr.ssa Ornella Vitale",
  },
];

/* ═══ PAI Active Data for patients in care ═══ */
export const paiActiveData = {
  3: {
    dataInizioPAI: "20/01/2026", dataFinePAI: "20/02/2026",
    obiettiviPAI: [
      { area: "Mobilita", obiettivo: "Recupero deambulazione autonoma con ausilio", indicatore: "Barthel Index +15 in 30gg" },
      { area: "Autonomia", obiettivo: "Ripresa autonomia nelle ADL di base", indicatore: "Riduzione dipendenza igiene personale" },
    ],
    serviziAttivi: [
      { tipo: "Fisioterapia Domiciliare", frequenza: "5 volte/settimana", provider: "Coop. Salute Insieme", durata: "45 min" },
      { tipo: "Infermieristica", frequenza: "1 volta/giorno", provider: "Coop. Assistenza Roma", durata: "30 min" },
      { tipo: "OSS", frequenza: "2 volte/giorno", provider: "Coop. Salute Insieme", durata: "60 min" },
    ],
  },
  5: {
    dataInizioPAI: "19/01/2026", dataFinePAI: "25/02/2026",
    obiettiviPAI: [
      { area: "Cardiologico", obiettivo: "Stabilizzazione scompenso cardiaco", indicatore: "BNP < 300 pg/ml" },
      { area: "Sociale", obiettivo: "Attivazione rete supporto sociale", indicatore: "Piano assistenziale integrato attivo" },
    ],
    serviziAttivi: [
      { tipo: "Infermieristica Domiciliare", frequenza: "1 volta/giorno", provider: "Fond. Cura Domiciliare", durata: "45 min" },
      { tipo: "Monitoraggio Cardiologico", frequenza: "2 volte/settimana", provider: "Fond. Cura Domiciliare", durata: "30 min" },
    ],
  },
  6: {
    dataInizioPAI: "18/01/2026", dataFinePAI: "18/04/2026",
    obiettiviPAI: [
      { area: "Neuromotorio", obiettivo: "Recupero funzionale emiparesi sinistra", indicatore: "FIM Score +20 in 60gg" },
      { area: "Logopedia", obiettivo: "Recupero deglutizione sicura", indicatore: "Scala DOSS livello 5" },
    ],
    serviziAttivi: [
      { tipo: "Fisioterapia Neuromotoria", frequenza: "5 volte/settimana", provider: "Consorzio ADI Lazio", durata: "60 min" },
      { tipo: "Logopedia", frequenza: "3 volte/settimana", provider: "Coop. Assistenza Roma", durata: "45 min" },
      { tipo: "Infermieristica", frequenza: "1 volta/giorno", provider: "Consorzio ADI Lazio", durata: "30 min" },
      { tipo: "OSS", frequenza: "2 volte/giorno", provider: "Coop. Il Sorriso", durata: "90 min" },
    ],
  },
  7: {
    dataInizioPAI: "16/01/2026", dataFinePAI: "16/04/2026",
    obiettiviPAI: [
      { area: "Cognitivo", obiettivo: "Rallentamento deterioramento cognitivo", indicatore: "MMSE stabile a 6 mesi" },
      { area: "Gestione Farmaci", obiettivo: "Somministrazione insulina sicura", indicatore: "HbA1c < 7.5%" },
    ],
    serviziAttivi: [
      { tipo: "Infermieristica Domiciliare", frequenza: "2 volte/giorno", provider: "Fond. Cura Domiciliare", durata: "30 min" },
      { tipo: "OSS", frequenza: "2 volte/giorno", provider: "Coop. Il Sorriso", durata: "90 min" },
      { tipo: "Stimolazione Cognitiva", frequenza: "2 volte/settimana", provider: "Coop. Assistenza Roma", durata: "45 min" },
    ],
  },
  8: {
    dataInizioPAI: "14/01/2026", dataFinePAI: "14/04/2026",
    obiettiviPAI: [
      { area: "Cute", obiettivo: "Guarigione ulcere da pressione stadio III", indicatore: "Riduzione area lesionale 50% in 30gg" },
      { area: "Nutrizione", obiettivo: "Recupero stato nutrizionale", indicatore: "Albumina > 3.0 g/dL" },
    ],
    serviziAttivi: [
      { tipo: "Infermieristica Avanzata", frequenza: "2 volte/giorno", provider: "Fond. Cura Domiciliare", durata: "60 min" },
      { tipo: "OSS", frequenza: "3 volte/giorno", provider: "Coop. Salute Insieme", durata: "60 min" },
      { tipo: "Nutrizione Enterale", frequenza: "Continua", provider: "Fond. Cura Domiciliare", durata: "Monitoraggio" },
    ],
  },
  11: {
    dataInizioPAI: "14/01/2026", dataFinePAI: "28/02/2026",
    obiettiviPAI: [
      { area: "Motorio", obiettivo: "Prevenzione cadute e miglioramento equilibrio", indicatore: "Tinetti Scale +5 in 30gg" },
      { area: "Deglutizione", obiettivo: "Sicurezza nella deglutizione", indicatore: "Assenza episodi ab-ingestis" },
    ],
    serviziAttivi: [
      { tipo: "Fisioterapia", frequenza: "3 volte/settimana", provider: "Consorzio ADI Lazio", durata: "45 min" },
      { tipo: "Logopedia", frequenza: "2 volte/settimana", provider: "Coop. Assistenza Roma", durata: "40 min" },
      { tipo: "Infermieristica", frequenza: "1 volta/giorno", provider: "Consorzio ADI Lazio", durata: "30 min" },
    ],
  },
  14: {
    dataInizioPAI: "12/01/2026", dataFinePAI: "12/04/2026",
    obiettiviPAI: [
      { area: "Cognitivo", obiettivo: "Gestione sintomi comportamentali", indicatore: "NPI riduzione 30% in 60gg" },
      { area: "Continenza", obiettivo: "Gestione incontinenza", indicatore: "Riduzione episodi notturni" },
    ],
    serviziAttivi: [
      { tipo: "OSS", frequenza: "2 volte/giorno", provider: "Coop. Il Sorriso", durata: "90 min" },
      { tipo: "Infermieristica", frequenza: "3 volte/settimana", provider: "Coop. Salute Insieme", durata: "30 min" },
    ],
  },
  15: {
    dataInizioPAI: "22/01/2026", dataFinePAI: "22/02/2026",
    obiettiviPAI: [
      { area: "Motorio", obiettivo: "Contenimento spasticita e prevenzione contratture", indicatore: "Ashworth Scale stabile" },
      { area: "Cute", obiettivo: "Prevenzione lesioni da pressione", indicatore: "Braden Scale > 15" },
    ],
    serviziAttivi: [
      { tipo: "Fisioterapia Intensiva", frequenza: "5 volte/settimana", provider: "Consorzio ADI Lazio", durata: "60 min" },
      { tipo: "Infermieristica", frequenza: "1 volta/giorno", provider: "Coop. Salute Insieme", durata: "45 min" },
      { tipo: "OSS", frequenza: "2 volte/giorno", provider: "Coop. Il Sorriso", durata: "60 min" },
    ],
  },
  20: {
    dataInizioPAI: "28/01/2026", dataFinePAI: "28/04/2026",
    obiettiviPAI: [
      { area: "Metabolico", obiettivo: "Compenso glicemico ottimale", indicatore: "HbA1c < 7.0%" },
      { area: "Piede Diabetico", obiettivo: "Guarigione ulcera plantare", indicatore: "Chiusura lesione in 45gg" },
    ],
    serviziAttivi: [
      { tipo: "Infermieristica Domiciliare", frequenza: "1 volta/giorno", provider: "Fond. Cura Domiciliare", durata: "45 min" },
      { tipo: "Monitoraggio Glicemico", frequenza: "2 volte/settimana", provider: "Fond. Cura Domiciliare", durata: "20 min" },
    ],
  },
  22: {
    dataInizioPAI: "29/01/2026", dataFinePAI: "29/04/2026",
    obiettiviPAI: [
      { area: "Dolore", obiettivo: "Controllo dolore oncologico (VAS < 3)", indicatore: "VAS < 3 stabile" },
      { area: "Palliativo", obiettivo: "Qualita di vita e comfort", indicatore: "POS Score miglioramento" },
    ],
    serviziAttivi: [
      { tipo: "Cure Palliative", frequenza: "Quotidiana", provider: "Fond. Cura Domiciliare", durata: "60 min" },
      { tipo: "Infermieristica Specialistica", frequenza: "2 volte/giorno", provider: "Fond. Cura Domiciliare", durata: "45 min" },
      { tipo: "Supporto Psicologico", frequenza: "1 volta/settimana", provider: "Coop. Assistenza Roma", durata: "50 min" },
    ],
  },
  25: {
    dataInizioPAI: "02/02/2026", dataFinePAI: "02/05/2026",
    obiettiviPAI: [
      { area: "Cognitivo", obiettivo: "Gestione wandering e agitazione", indicatore: "Riduzione episodi settimanali" },
      { area: "Pressorio", obiettivo: "Stabilizzazione valori pressori", indicatore: "PA < 140/90 mmHg" },
    ],
    serviziAttivi: [
      { tipo: "OSS", frequenza: "2 volte/giorno", provider: "Coop. Il Sorriso", durata: "90 min" },
      { tipo: "Infermieristica", frequenza: "1 volta/giorno", provider: "Coop. Salute Insieme", durata: "30 min" },
    ],
  },
  28: {
    dataInizioPAI: "04/02/2026", dataFinePAI: "01/03/2026",
    obiettiviPAI: [
      { area: "Respiratorio", obiettivo: "Gestione dispnea e comfort respiratorio", indicatore: "SpO2 > 92% stabile" },
      { area: "Palliativo", obiettivo: "Controllo sintomi e supporto familiare", indicatore: "ESAS Score < 30" },
    ],
    serviziAttivi: [
      { tipo: "Cure Palliative Domiciliari", frequenza: "Quotidiana", provider: "Fond. Cura Domiciliare", durata: "60 min" },
      { tipo: "Infermieristica H12", frequenza: "Continua", provider: "Fond. Cura Domiciliare", durata: "12h" },
      { tipo: "Supporto Psicologico Familiare", frequenza: "2 volte/settimana", provider: "Coop. Assistenza Roma", durata: "50 min" },
    ],
  },
  30: {
    dataInizioPAI: "06/02/2026", dataFinePAI: "27/02/2026",
    obiettiviPAI: [
      { area: "Motorio", obiettivo: "Mantenimento mobilita residua", indicatore: "FIM Score stabile" },
      { area: "Deglutizione", obiettivo: "Gestione disfagia e prevenzione ab-ingestis", indicatore: "Scala DOSS livello 4" },
    ],
    serviziAttivi: [
      { tipo: "Fisioterapia", frequenza: "3 volte/settimana", provider: "Consorzio ADI Lazio", durata: "45 min" },
      { tipo: "Logopedia", frequenza: "2 volte/settimana", provider: "Coop. Assistenza Roma", durata: "40 min" },
      { tipo: "OSS", frequenza: "2 volte/giorno", provider: "Coop. Il Sorriso", durata: "90 min" },
    ],
  },
  33: {
    dataInizioPAI: "08/02/2026", dataFinePAI: "08/05/2026",
    obiettiviPAI: [
      { area: "Motorio", obiettivo: "Prevenzione cadute da neuropatia", indicatore: "Berg Balance Scale +5" },
      { area: "Metabolico", obiettivo: "Compenso glicemico", indicatore: "HbA1c < 7.5%" },
    ],
    serviziAttivi: [
      { tipo: "Fisioterapia", frequenza: "3 volte/settimana", provider: "Consorzio ADI Lazio", durata: "45 min" },
      { tipo: "Infermieristica", frequenza: "3 volte/settimana", provider: "Coop. Salute Insieme", durata: "30 min" },
    ],
  },
  37: {
    dataInizioPAI: "11/02/2026", dataFinePAI: "11/05/2026",
    obiettiviPAI: [
      { area: "Protesico", obiettivo: "Addestramento deambulazione con protesi", indicatore: "Autonomia con ausilio in 60gg" },
      { area: "Moncone", obiettivo: "Guarigione e adattamento moncone", indicatore: "Assenza complicanze" },
    ],
    serviziAttivi: [
      { tipo: "Fisioterapia Protesica", frequenza: "5 volte/settimana", provider: "Consorzio ADI Lazio", durata: "60 min" },
      { tipo: "Infermieristica", frequenza: "1 volta/giorno", provider: "Coop. Salute Insieme", durata: "30 min" },
    ],
  },
  41: {
    dataInizioPAI: "14/02/2026", dataFinePAI: "14/05/2026",
    obiettiviPAI: [
      { area: "Renale", obiettivo: "Stabilizzazione funzionalita renale", indicatore: "GFR stabile > 30 ml/min" },
      { area: "Immunologico", obiettivo: "Gestione terapia immunosoppressiva", indicatore: "Assenza riacutizzazioni" },
    ],
    serviziAttivi: [
      { tipo: "Infermieristica Specialistica", frequenza: "1 volta/giorno", provider: "Fond. Cura Domiciliare", durata: "30 min" },
      { tipo: "Monitoraggio Nefrologico", frequenza: "2 volte/settimana", provider: "Fond. Cura Domiciliare", durata: "20 min" },
    ],
  },
  45: {
    dataInizioPAI: "16/02/2026", dataFinePAI: "16/05/2026",
    obiettiviPAI: [
      { area: "Linfedema", obiettivo: "Riduzione linfedema arto superiore", indicatore: "Riduzione circonferenza 2cm in 30gg" },
      { area: "Psicologico", obiettivo: "Supporto elaborazione psicologica", indicatore: "PHQ-9 < 10" },
    ],
    serviziAttivi: [
      { tipo: "Linfodrenaggio Manuale", frequenza: "3 volte/settimana", provider: "Consorzio ADI Lazio", durata: "60 min" },
      { tipo: "Supporto Psicologico", frequenza: "1 volta/settimana", provider: "Coop. Assistenza Roma", durata: "50 min" },
    ],
  },
};

export const mediciValutatori = [
  { id: 1, nome: "Dr.ssa Elena Moretti", specializzazione: "Geriatria", carico: 4 },
  { id: 2, nome: "Dr. Marco Vitale", specializzazione: "Medicina Interna", carico: 3 },
  { id: 3, nome: "Dr.ssa Sofia Gatti", specializzazione: "Neurologia", carico: 2 },
  { id: 4, nome: "Dr. Roberto Santoro", specializzazione: "Fisiatria", carico: 5 },
];

export const providers = [
  { id: 1, nome: "Cooperativa Salute Insieme", punteggio: 92, carico: 34, disponibilita: true, specializzazioni: ["Infermieristica", "Fisioterapia", "OSS"] },
  { id: 2, nome: "Cooperativa Assistenza Roma", punteggio: 88, carico: 41, disponibilita: true, specializzazioni: ["Infermieristica", "Logopedia", "OSS"] },
  { id: 3, nome: "Fondazione Cura Domiciliare", punteggio: 95, carico: 28, disponibilita: true, specializzazioni: ["Infermieristica", "Fisioterapia", "Nutrizione"] },
  { id: 4, nome: "Cooperativa Il Sorriso", punteggio: 85, carico: 47, disponibilita: false, specializzazioni: ["OSS", "Igiene personale"] },
  { id: 5, nome: "Consorzio ADI Lazio", punteggio: 90, carico: 38, disponibilita: true, specializzazioni: ["Infermieristica", "Fisioterapia", "Logopedia", "OSS"] },
];

export const interraiSections = [
  {
    id: "cognitive",
    titolo: "Performance Cognitiva",
    campi: [
      { id: "memoria_breve", label: "Memoria a breve termine", tipo: "select", opzioni: ["0 - OK", "1 - Problema memoria"], valore: "0 - OK" },
      { id: "capacita_decisionale", label: "Capacità decisionale", tipo: "select", opzioni: ["0 - Indipendente", "1 - Difficoltà minima", "2 - Difficoltà moderata", "3 - Gravemente compromessa"], valore: "1 - Difficoltà minima" },
      { id: "comunicazione", label: "Farsi comprendere", tipo: "select", opzioni: ["0 - Comprensibile", "1 - Di solito comprensibile", "2 - Spesso incomprensibile"], valore: "0 - Comprensibile" },
    ]
  },
  {
    id: "functional",
    titolo: "Stato Funzionale (ADL/IADL)",
    campi: [
      { id: "igiene", label: "Igiene personale", tipo: "select", opzioni: ["0 - Indipendente", "1 - Supervisione", "2 - Assistenza limitata", "3 - Assistenza totale"], valore: "2 - Assistenza limitata" },
      { id: "mobilita", label: "Mobilità nel letto", tipo: "select", opzioni: ["0 - Indipendente", "1 - Supervisione", "2 - Assistenza limitata", "3 - Assistenza totale"], valore: "1 - Supervisione" },
      { id: "trasferimenti", label: "Trasferimenti", tipo: "select", opzioni: ["0 - Indipendente", "1 - Supervisione", "2 - Assistenza limitata", "3 - Assistenza totale"], valore: "2 - Assistenza limitata" },
      { id: "deambulazione", label: "Deambulazione", tipo: "select", opzioni: ["0 - Indipendente", "1 - Supervisione", "2 - Assistenza limitata", "3 - Assistenza totale", "4 - Non deambula"], valore: "3 - Assistenza totale" },
      { id: "preparazione_pasti", label: "Preparazione pasti (IADL)", tipo: "select", opzioni: ["0 - Indipendente", "1 - Supervisione", "2 - Assistenza limitata", "3 - Non in grado"], valore: "3 - Non in grado" },
      { id: "gestione_farmaci", label: "Gestione farmaci (IADL)", tipo: "select", opzioni: ["0 - Indipendente", "1 - Supervisione", "2 - Non in grado"], valore: "1 - Supervisione" },
    ]
  },
  {
    id: "continence",
    titolo: "Continenza e Nutrizione",
    campi: [
      { id: "continenza_urinaria", label: "Continenza urinaria", tipo: "select", opzioni: ["0 - Continente", "1 - Di solito continente", "2 - Frequentemente incontinente", "3 - Incontinente"], valore: "1 - Di solito continente" },
      { id: "catetere", label: "Catetere vescicale", tipo: "select", opzioni: ["No", "Sì"], valore: "No" },
      { id: "perdita_peso", label: "Perdita di peso", tipo: "select", opzioni: ["0 - Nessuna", "1 - 1-2 kg", "2 - >2 kg"], valore: "1 - 1-2 kg" },
      { id: "nutrizione_enterale", label: "Nutrizione enterale/parenterale", tipo: "select", opzioni: ["No", "Sì"], valore: "No" },
    ]
  },
  {
    id: "health",
    titolo: "Condizioni di Salute",
    campi: [
      { id: "dispnea", label: "Dispnea", tipo: "select", opzioni: ["0 - Assente", "1 - Sotto sforzo", "2 - A riposo"], valore: "0 - Assente" },
      { id: "dolore", label: "Dolore", tipo: "select", opzioni: ["0 - Nessuno", "1 - Lieve", "2 - Moderato", "3 - Severo"], valore: "2 - Moderato" },
      { id: "cadute", label: "Cadute recenti (90gg)", tipo: "select", opzioni: ["0 - Nessuna", "1 - Una caduta", "2 - Due o più cadute"], valore: "1 - Una caduta" },
      { id: "ulcere_pressione", label: "Ulcere da pressione", tipo: "select", opzioni: ["0 - Nessuna", "1 - Stadio I", "2 - Stadio II", "3 - Stadio III", "4 - Stadio IV"], valore: "0 - Nessuna" },
    ]
  },
];

export const paiTemplate = {
  obiettivi: [
    { id: 1, area: "Mobilità", obiettivo: "Miglioramento deambulazione assistita", indicatore: "Barthel Index +10 punti in 30gg", priorita: "alta" },
    { id: 2, area: "Nutrizione", obiettivo: "Supporto nutrizionale e recupero peso corporeo", indicatore: "Recupero 1kg in 15gg", priorita: "media" },
    { id: 3, area: "Gestione Dolore", obiettivo: "Riduzione scala VAS a <3", indicatore: "VAS < 3 entro 7gg", priorita: "alta" },
    { id: 4, area: "Autonomia ADL", obiettivo: "Incremento autonomia igiene personale", indicatore: "Riduzione dipendenza da livello 3 a 2", priorita: "media" },
  ],
  prestazioni: [
    { id: 1, tipo: "Infermiere", frequenza: "Accesso giornaliero", durata: "60 min", note: "Medicazioni, somministrazione terapia" },
    { id: 2, tipo: "Fisioterapista", frequenza: "3 volte/settimana", durata: "45 min", note: "Riabilitazione motoria, rinforzo arti inferiori" },
    { id: 3, tipo: "OSS", frequenza: "2 volte/giorno", durata: "90 min", note: "Igiene personale, mobilizzazione, supporto pasti" },
    { id: 4, tipo: "Medico Specialista", frequenza: "1 volta/settimana", durata: "30 min", note: "Monitoraggio clinico, aggiustamento terapia" },
  ],
  bodyAreas: [
    /* Modello Maschile */
    { id: 'male_head', model: 'male', label: 'Testa / Cognitivo', severity: 1, note: 'Deficit cognitivo lieve — Mini-Mental 22/30' },
    { id: 'male_chest', model: 'male', label: 'Torace / Respiratorio', severity: 0, note: 'Nella norma — Auscultazione MV presente bilateralmente' },
    { id: 'male_abdomen', model: 'male', label: 'Addome / Nutrizione', severity: 2, note: 'Moderato — Perdita di peso involontaria 8%, supporto nutrizionale indicato' },
    { id: 'male_leftArm', model: 'male', label: 'Arto Sup. SX', severity: 1, note: 'Lieve — Ridotta forza prensile, grip test 18kg' },
    { id: 'male_rightArm', model: 'male', label: 'Arto Sup. DX', severity: 0, note: 'Nella norma' },
    { id: 'male_rightKnee', model: 'male', label: 'Ginocchio DX', severity: 1, note: 'Lieve — Artrosi articolare lieve, crepitio alla mobilizzazione' },
    { id: 'male_rightAnkle', model: 'male', label: 'Caviglia DX', severity: 2, note: 'Moderato — Tendinite cronica, limitazione dorsi-flessione' },
    { id: 'male_leftLeg', model: 'male', label: 'Arto Inf. SX', severity: 3, note: 'Grave — Grave limitazione mobilita, deambulazione con ausilio' },
    /* Modello Femminile */
    { id: 'female_head', model: 'female', label: 'Testa / Cognitivo', severity: 0, note: 'Nella norma — MMSE 28/30' },
    { id: 'female_neck', model: 'female', label: 'Collo / Cervicale', severity: 2, note: 'Moderato — Cervicalgia cronica, rigidita rotatoria bilaterale' },
    { id: 'female_shoulders', model: 'female', label: 'Spalle', severity: 3, note: 'Grave — Grave artrosi scapolo-omerale bilaterale, ROM < 90 gradi' },
    { id: 'female_chest', model: 'female', label: 'Torace / Respiratorio', severity: 1, note: 'Lieve — Dispnea da sforzo moderato, SpO2 94%' },
    { id: 'female_abdomen', model: 'female', label: 'Addome / Nutrizione', severity: 0, note: 'Nella norma — Stato nutrizionale adeguato' },
    { id: 'female_leftLeg', model: 'female', label: 'Arto Inf. SX', severity: 2, note: 'Moderato — Moderata limitazione mobilita, rischio caduta' },
    { id: 'female_rightLeg', model: 'female', label: 'Arto Inf. DX', severity: 1, note: 'Lieve — Edema perimalleolare intermittente' },
    { id: 'female_skin', model: 'female', label: 'Cute / Tegumenti', severity: 1, note: 'Lieve — Rischio ulcere da decubito, Braden 16/23' },
  ],
};

export const caseManagerTimelines = [
  {
    patientId: 7,
    paziente: "Elena Ferrara",
    steps: [
      { label: "Richiesta", data: "12/01", completato: true },
      { label: "Valutazione UVMD", data: "15/01", completato: true, giorni: 3 },
      { label: "Definizione PAI", data: "16/01", completato: true, giorni: 1 },
      { label: "Assegnazione", data: "", completato: false, giorni: 2, attivo: true },
      { label: "Attivazione", data: "", completato: false, giorni: null },
    ]
  },
  {
    patientId: 8,
    paziente: "Marco Ricci",
    steps: [
      { label: "Richiesta", data: "11/01", completato: true },
      { label: "Valutazione UVMD", data: "13/01", completato: true, giorni: 2 },
      { label: "Definizione PAI", data: "14/01", completato: true, giorni: 1 },
      { label: "Assegnazione", data: "", completato: false, giorni: 3, attivo: true },
      { label: "Attivazione", data: "", completato: false, giorni: null },
    ]
  },
  {
    patientId: 3,
    paziente: "Anna Verdi",
    steps: [
      { label: "Richiesta", data: "14/01", completato: true },
      { label: "Valutazione UVMD", data: "20/01", completato: true, giorni: 6 },
      { label: "Definizione PAI", data: "", completato: false, giorni: null, attivo: true },
      { label: "Assegnazione", data: "", completato: false, giorni: null },
      { label: "Attivazione", data: "", completato: false, giorni: null },
    ]
  },
];

/* complessita field removed — priorita is the single source of truth */
